import { useMemo } from 'react';
import { useApiWorkspacesIdGet } from '@r/api/generated/client.ts';
import type { UserMeReadModel, UserWorkspaceMeReadModel } from '@r/api/generated/client.schemas.ts';
import { getActiveWorkspaceUniversal } from '@r/helpers/api.ts';
import { isAdminRole } from '@r/utils/roles.ts';

type User = Pick<UserMeReadModel, 'id' | 'visibleWorkspaces'>;

export const UseWorkspace = (user: User | null | undefined) => {
  const activeWorkspace: UserWorkspaceMeReadModel | undefined = user?.visibleWorkspaces
    ? getActiveWorkspaceUniversal<UserWorkspaceMeReadModel>(user.visibleWorkspaces)
    : undefined;

  const workspaceId = activeWorkspace?.workspace?.id?.toString() ?? '';
  const isRegistered = activeWorkspace?.status === 'user.status.registered';

  const mustChangePassword = activeWorkspace?.passwordNeedToBeChanged;

  const isAdmin = isAdminRole(activeWorkspace?.maxRole);

  const canFetchWorkspace =
    Boolean(user && activeWorkspace) && ((isRegistered && !mustChangePassword) || isAdmin);

  const workspaceQuery = useApiWorkspacesIdGet(workspaceId, {
    query: {
      queryKey: ['workspace', user?.id, workspaceId],
      staleTime: Number.POSITIVE_INFINITY,
      enabled: canFetchWorkspace
    }
  });

  return useMemo(
    () => ({
      workspace: workspaceQuery.data,
      isWorkspacePending: workspaceQuery.isPending,
      isWorkspaceError: workspaceQuery.isError,
      isWorkspaceSuccess: workspaceQuery.isSuccess
    }),
    [
      workspaceQuery.data,
      workspaceQuery.isPending,
      workspaceQuery.isError,
      workspaceQuery.isSuccess
    ]
  );
};
